<template>
	<div>
		<v-layout justify-space-around row wrap>
			<v-flex
				v-if="
					dataProp.renderMode != 'parsed' && selectedFile.extension == 'pdf'
				"
				align-end
				xs6
			>
				<AlternateTransformConfig v-model="alternateTransformConfig" />
			</v-flex>
			<v-flex xs6>
				<v-btn color="blue darken-3" outline @click="fetchFileJSON"
					>Original {{ dataProp.renderMode.toUpperCase() }}</v-btn
				>
			</v-flex>
		</v-layout>
		<v-card flat>
			<v-card-text>
				<v-layout justify-space-around>
					<v-flex xs5>
						<v-text-field
							v-model="headerArray"
							label="Enter Header Array"
							ma-2
							class="g2"
						></v-text-field>
						<v-text-field
							v-model="headerKey"
							label="Enter Header Key"
							ma-2
							class="g2"
						></v-text-field>
						<center>
							<v-btn outline flat color="orange darken-1" @click="runMap"
								>Run map</v-btn
							>
						</center>
						<center>
							<code>{{ headerArrayJSON }}</code>
						</center>
					</v-flex>
					<v-flex xs5>
						<v-text-field
							v-model="headerSequenceInput"
							label="Enter Array to get char sequence"
							ma-2
							class="g2"
						></v-text-field>
						<center>
							<v-btn
								outline
								flat
								color="orange darken-1"
								@click="getCharSequence"
								>Get Char</v-btn
							>
						</center>
						<v-text-field
							v-model="headerLimitInput"
							label="Enter alphabet to get char sequence"
							ma-2
							class="g2"
							@keyup="generateCharSequence($event)"
						></v-text-field>
						<center>
							<!-- <v-btn outline flat color="green darken-1" @click="generateCharSequence">Generate Seq</v-btn> -->
						</center>
						<center>
							<code>{{ sequenceArray }}</code>
						</center>
					</v-flex>
				</v-layout>
				<brace
					style="height:90vh;"
					class="kbet-editor"
					:mode="'json'"
					@code-change="onEditorCodeChange"
					@setHandler="
						h => {
							editorHandler = h;
						}
					"
				/>
			</v-card-text>
		</v-card>
		<v-btn
			v-if="
				dataProp.renderMode != 'parsed' &&
					(selectedFile.extension == 'pdf' ||
						/xl/gi.test(selectedFile.extension))
			"
			color="blue darken-1"
			small
			absolute
			top
			right
			fab
			@click="jsonToText"
		>
			<v-icon>{{ textMode ? 'code' : 'text_fields' }}</v-icon>
		</v-btn>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import AlternateTransformConfig from '../../components/alternateTransformConfig';
import { setTimeout, clearTimeout } from 'timers';
import axios from 'axios';
export default {
	data() {
		return {
			editorHandler: false,
			displayJSON: false,
			headerArray: '',
			headerKey: 'str',
			headerArrayJSON: [],
			textMode: false,
			originalFileData: [],
			alternateTransformConfig: {},
			headerSequenceInput: '',
			headerLimitInput: '',
			months: [
				'Jan',
				'Feb',
				'Mar',
				'Apr',
				'May',
				'Jun',
				'Jul',
				'Aug',
				'Sept',
				'Sep',
				'Oct',
				'Nov',
				'Dec',
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December',
			],
			sequenceArray: [],
		};
	},
	components: {
		AlternateTransformConfig,
	},
	created() {},
	methods: {
		...mapMutations(['openSnackbar']),
		...mapMutations('rejectedMetaTwo', [
			'setIdHeaders',
			'setParserConfig',
			'setCharacterHeaderSequence',
		]),
		...mapActions('rejectedMetaTwo', ['getFileJSON', 'getAlternateTransform']),
		onEditorCodeChange(code) {
			this.editorCode = code;
			// console.log(code);
		},
		runMap() {
			this.setIdHeaders([]);
			if (this.headerArray && JSON.parse(this.headerArray) && this.headerKey) {
				this.headerArrayJSON = JSON.parse(this.headerArray).map(
					e => e[this.headerKey]
				);
				this.setIdHeaders(this.headerArrayJSON);
			}
		},
		jsonToText() {
			if (this.jsonValidate(this.editorCode)) {
				if (!this.textMode) {
					let transformedFileData = JSON.parse(
						JSON.stringify(this.originalFileData)
					);
					let textArray = [];
					for (let i of transformedFileData) {
						for (let j of i) {
							textArray.push(j.str);
						}
					}
					this.editorHandler.setValue(JSON.stringify(textArray, null, 2));
				} else {
					this.editorHandler.setValue(
						JSON.stringify(this.originalFileData, null, 2)
					);
				}
				this.textMode = !this.textMode;
			} else {
				this.openSnackbar({
					text: 'Invalid JSON please fix the error',
				});
			}
		},
		jsonValidate(json) {
			try {
				JSON.parse(json);
				return true;
			} catch (err) {
				return false;
			}
		},
		fetchFileJSON() {
			this.getFileJSON({
				renderMode: this.dataProp.renderMode,
				filePathURL: '?uuid=' + this.selectedFile.filename.split('.')[0],
			}).then(data => {
				this.originalFileData = data;
				this.editorHandler.setValue(JSON.stringify(data, null, 2));
			});
		},
		fetchAlternateFileJSON(config) {
			let CancelToken = axios.CancelToken;
			let cancel, timeout;
			this.getAlternateTransform({
				...config,
				uuid: this.selectedFile.filename.split('.')[0],
				cancelToken: new CancelToken(function(c) {
					cancel = c;
				}),
			})
				.then(data => {
					clearTimeout(timeout);
					this.originalFileData = data;
					this.editorHandler.setValue(JSON.stringify(data, null, 2));
					this.setParserConfig(config);
					this.$nextTick(() => {
						if (config.mode == 'transformv2') {
							this.figureOutIdHeaders(data);
						} else {
							this.figureOutIdHeaders(data, false);
						}
					});
				})
				.catch(e => {
					console.log('fetchAlternateFileJSON error', e);
				});
			timeout = setTimeout(() => {
				cancel();
			}, 5000);
		},
		escape(s) {
			return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
		},
		figureOutIdHeaders(data, regularMode = true) {
			if (
				!['csv', 'txt', 'text'].includes(this.selectedFile.extension) &&
				regularMode
			) {
				let product = require('../../components/product.json');
				let potentialHeaderArrays = Object.assign([], data.slice(0, 50));

				let possibleHeaderArray = [];
				for (let potentialHeaderArray of potentialHeaderArrays) {
					let temp = potentialHeaderArray
						.map(e => e.str)
						.join(' ')
						.trim();
					// console.log(temp);
					let numCount = temp.match(/\d+/g) ? temp.match(/\d+/g).length : 0;
					for (let nameTypes of product) {
						if (
							new RegExp(this.escape(nameTypes), 'ig').test(temp) &&
							!(numCount > 3)
						) {
							// console.log(nameTypes);
							// figure out if there is a month in the name and make that string a star
							if (potentialHeaderArray.length > 1) {
								for (let header in potentialHeaderArray) {
									for (let month of this.months) {
										if (
											new RegExp(escape(month), 'ig').test(
												potentialHeaderArray[header].str
											)
										) {
											// console.log(potentialHeaderArray[header], month);
											potentialHeaderArray[header].str = '*';
										}
									}
								}
							}
							possibleHeaderArray.push(potentialHeaderArray);
							break;
						}
					}
					// if (possibleHeaderArray.length > 0) {
					// 	break;
					// }
				}

				possibleHeaderArray = possibleHeaderArray.sort((a, b) => {
					return a.length - b.length;
				});
				// console.log('Sorted Result----->', possibleHeaderArray);
				if (
					potentialHeaderArrays.length > 0 &&
					possibleHeaderArray.length == 0
				) {
					possibleHeaderArray = potentialHeaderArrays[0];
				}
				this.headerArray = JSON.stringify(
					possibleHeaderArray[possibleHeaderArray.length - 1]
				);
				this.runMap();
				// console.log(potentialHeaderArrays, possibleHeaderArray);
			} else {
				let product = require('../../components/product.json');
				let potentialHeaderArrays = Object.assign([], data.slice(0, 35));
				potentialHeaderArrays.sort(function(a, b) {
					return b.length - a.length;
				});
				let possibleHeaderArray = [];
				for (let potentialHeaderArray of potentialHeaderArrays) {
					let numCount = potentialHeaderArray.match(/\d+/g)
						? potentialHeaderArray.match(/\d+/g).length
						: 0;
					for (let nameTypes of product) {
						if (
							new RegExp(this.escape(nameTypes), 'ig').test(
								potentialHeaderArray
							) &&
							!(numCount > 3)
						) {
							possibleHeaderArray.push(potentialHeaderArray);
							break;
						}
					}

					// if (possibleHeaderArray.length > 0) {
					// 	break;
					// }
				}

				possibleHeaderArray = possibleHeaderArray.sort((a, b) => {
					return b.length - a.length;
				});
				// console.log(possibleHeaderArray);
				if (
					potentialHeaderArrays.length > 0 &&
					possibleHeaderArray.length == 0
				) {
					possibleHeaderArray = potentialHeaderArrays[0];
				}
				// console.log(possibleHeaderArray)
				if (
					this.selectedFile.extension == 'csv' &&
					possibleHeaderArray[0].split(',').length > 2
				) {
					this.setIdHeaders(possibleHeaderArray[0].split(','));
				} else {
					this.setIdHeaders([possibleHeaderArray[0]]);
				}
			}
		},
		generateCharSequence(e) {
			if (/xl/gi.test(this.selectedFile.extension)) {
				if (
					/[a-z]/gi.test(e.key) &&
					e.key.length == 1 &&
					this.headerLimitInput.length == 1
				) {
					let alphabets = 'abcdefghijklmnopqrstuvwxyz'.split('');
					let tempArray = [];
					for (let alphabet of alphabets) {
						if (alphabet !== e.key.toLowerCase()) {
							tempArray.push(alphabet);
							continue;
						}
						tempArray.push(alphabet);
						break;
					}
					this.sequenceArray = tempArray;
					this.setCharacterHeaderSequence(this.sequenceArray);
					this.$emit('switchTab', 'tab-2');
				}
			}
		},
		getCharSequence() {
			if (/xl/gi.test(this.selectedFile.extension)) {
				if (this.headerSequenceInput && JSON.parse(this.headerSequenceInput)) {
					this.sequenceArray = JSON.parse(this.headerSequenceInput).map(
						e => e['cellChar']
					);
					this.setCharacterHeaderSequence(this.sequenceArray);
					this.$emit('switchTab', 'tab-2');
				}
			}
		},
	},
	computed: {
		...mapGetters('rejectedMetaTwo', ['selectedFile']),
	},
	mounted() {
		if (this.dataProp.renderMode != 'parsed') {
			this.fetchFileJSON();
		}
	},
	watch: {
		alternateTransformConfig(newValue, currentValue) {
			// console.log(newValue, currentValue);
			this.fetchAlternateFileJSON(newValue);
		},
	},
	props: ['dataProp'],
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}
</style>
